export type ZekjuTransportAllocation = {
  successful: boolean;
  data: {
    transportAllocationId: string;
    anonymousAccessUrl: string;
    conferenceUrl: string;
  };
};

export type LocationAddress = {
  streetAddress: string;
  postalCode: string;
  city: string;
  country: string;
};

export type StopZekju = {
  stopType: string;
  locationName: string;
  locationAddress: LocationAddress;
  timeSlotStart: string;
  timeSlotEnd: string;
  referenceIds: string[];
  referenceRemarks?: string[];
  remarks?: string;
};

export type Transport = {
  transportId: string;
  transportKey: string;
  groupingCode?: string;
  shipper?: string;
  remarks?: string;
  stops: StopZekju[];
};

export type Allocation = {
  receiverName: string;
  receiverEmail: string;
  receiverLanguage: string;
  driverPhone?: string;
  driverLanguage?: string;
  smsScheduledAt?: string;
};

export type ZekjuTransportAllocationPayLoad = {
  transport: Transport;
  allocation: Allocation;
};

export type ZekjuResponse = {
  successful: boolean;
  data: [
    {
      transportAllocationId: string;
      transportSource: string;
      transportId: string;
      transportKey: string;
      statusType: string;
      statusValue: string;
      reportedAt: string;
      referenceIds: string[];
    },
  ];
};
export type ZekjuDeleteResponse = {
  successful: boolean;
};
export type ZekjuProofOfDeliveryResponse = {
  successful: boolean;
  data: {
    fileName: string;
    fileExtension: string;
    contentType: string;
    content: string;
  };
};

export enum ZekjuStatus {
  LoadingStarted = 'LoadingStarted',
  LoadingArrived = 'LoadingArrived',
  LoadingCompleted = 'LoadingCompleted',
  LoadingDeparted = 'LoadingDeparted',
  LoadingSuccessful = 'LoadingSuccessful',
  LoadingProblem = 'LoadingProblem',
  LoadingFailed = 'LoadingFailed',

  UnloadingStarted = 'UnloadingStarted',
  UnloadingArrived = 'UnloadingArrived',
  UnloadingCompleted = 'UnloadingCompleted',
  UnloadingDeparted = 'UnloadingDeparted',
  UnloadingSuccessful = 'UnloadingSuccessful',
  UnloadingProblem = 'UnloadingProblem',
  UnloadingFailed = 'UnloadingFailed',
  TransportFinished = 'TransportFinished',
}
